"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = void 0;

var _ = require(".");

var _trackingAppName = require("./trackingAppName");

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
  * track events with category, action, and label to matomo
  *
  * @param {*} { category, action, label, element }
  */
var trackEvent = function trackEvent(_ref) {
  var context = _ref.context,
      category = _ref.category,
      action = _ref.action,
      label = _ref.label,
      element = _ref.element;
  var cat = "";
  var act = "";
  var lbl = "";
  var actionPrefix = "";

  if (category) {
    //// trk/old style
    var _actionPrefix = '';
    cat = category;
    _actionPrefix = cat.replace(/[^A-Z]/g, "");
    act = "".concat(_actionPrefix, " ").concat(action);
    lbl = label;
  } else {
    //// trkContext, trkAction, trkLabel => new style
    if (element) {
      var ctx = (0, _.findContext)(element);

      if (context) {
        ctx.splice(0, 0, context);
      }

      if ((0, _trackingAppName.getSharedTrackingAppName)().appName) {
        ctx.push((0, _trackingAppName.getSharedTrackingAppName)().appName);
      }

      ctx = ctx.reverse();
      cat = ctx.join(" > ");
      actionPrefix = cat.replace(/[^A-Z\>]/g, "");
      act = "".concat(action, " via ").concat(actionPrefix);
      lbl = label;
    } else //if we have direct context but no element
      if (context) {
        cat = context;
        actionPrefix = cat.replace(/[^A-Z\>]/g, "");
        act = "".concat(action, " via ").concat(actionPrefix);
        lbl = label;
      }
  } //// record event


  if (cat && act) {
    console.log("-- trackEvent --");
    console.log("-- cat", cat);
    console.log("-- act", act);
    console.log("-- lbl", lbl);
    console.log("---");
    var te = new CustomEvent('trc-track-event', {
      detail: {
        category: cat,
        action: act,
        label: lbl
      }
    });
    document.dispatchEvent(te);
  } else {
    console.log("---- WARNING trackEvent -----");
    console.log("-- props.category", category);
    console.log("-- props.context", context);
    console.log("-- props.action", action);
    console.log("-- props.label", label);
    console.log("-- props.element", element);
    console.log("-- cat", cat);
    console.log("-- act", act);
    console.log("-- lbl", lbl);
    console.log("---- -----"); //Send WARNINGs to matomo, should not loose event.

    if (act) {
      var _te = new CustomEvent('trc-track-event', {
        detail: {
          category: 'WARNING: UNKNOWN category',
          action: act,
          label: lbl
        }
      });

      document.dispatchEvent(_te);
    }
  }
};

exports.trackEvent = trackEvent;